import angular from 'angular';
import accountMenuDirective from './account-menu.directive';

let accountMenuModule = angular.module('catalog.category.accountMenu', [])
  .directive('accountMenu', accountMenuDirective);

export default accountMenuModule;



/** WEBPACK FOOTER **
 ** ./www/components/header-core/account-menu/account-menu.js
 **/